/**
 * 顾客单的费用链 —— 与后端 `AddOrderForm::saveOrderInfo`（contactfree-backend `api/models/form/AddOrderForm.php`
 * 2976-3048）逐步同义，取整只在 SUR / A3 / FEE / A5 四处，统一 PHP 7.4 的 round($x, 2)（`_phpRound2`）：
 *
 *   A1  = 小计 − 券                           不取整、不设下限。「券」就是 state.discountAmount = verify 返回的
 *                                             totalDiscount，与热修前（6bc2b810）逐字同义；券怎么算、要不要夹 0 前端一律不复刻
 *                                             （Option A 收口 / Codex 第 5 轮，owner 2026-09-29：券的一致性转 Q2 后端统一算价）
 *   SUR = round(A1 × 附加费率, 2)              `$surchargeAmount = round($order->amount * $surchargeRate, 2)`
 *   A3  = round(A1 + SUR, 2)                   整单券的零头就是在这一步被间接取整的
 *   A4  = A3 + 配送费                           不取整（`$order->amount += $baseFee`）
 *   FEE = round((A4 × 刷卡费率 × 100) / 100, 2) 后端原样写法，基数含附加费和配送费、不含小费
 *   A5  = round(A4 + FEE, 2)                   建单请求里的 amount；小费在 update-order 才加
 *
 * 顾客单的 `details.discounts` 后端只记账、不减钱（审计 Q10），这里没有 POS 手工折扣那一步。
 */
import { _phpRound2 } from '@/utils/number'

const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

/**
 * @param {{ subtotal: number, discount?: number, surchargeRate?: number|string, baseFee?: number|string, merchantRate?: number|string }} p
 *   subtotal 购物车小计；discount 券减掉的钱（verify 的 totalDiscount 原样）；
 *   surchargeRate / merchantRate 小数（0.015 = 1.5%）；baseFee 配送费（元）
 * @returns {{ A1: number, SUR: number, A3: number, A4: number, FEE: number, A5: number }}
 */
export function orderFeeChain({ subtotal, discount = 0, surchargeRate = 0, baseFee = 0, merchantRate = 0 }) {
  const A1 = num(subtotal) - num(discount)
  const SUR = _phpRound2(A1 * num(surchargeRate))
  const A3 = _phpRound2(A1 + SUR)
  const A4 = A3 + num(baseFee)
  const FEE = _phpRound2((A4 * num(merchantRate) * 100) / 100)
  const A5 = _phpRound2(A4 + FEE)
  return { A1, SUR, A3, A4, FEE, A5 }
}

/**
 * 小费金额 = round(比例 × 基数, 2)。后端不复核小费（审计 Q13），这里的取整只为让弹窗显示的数和实际扣的数是同一个；
 * 必须按**数值**算，不能从带本地化小数点的显示串反解析（EUR 的 "5,16" 会被 parseFloat 成 5，审计 UL-8）。
 * 基数沿用现状 = 订单 amount（含附加费与刷卡费，审计 UL-14 待 owner 定口径）。
 * @param {number|string} rate 小数（0.05 = 5%）
 * @param {number|string} base 元
 * @returns {number}
 */
export function tipAmountFor(rate, base) {
  return _phpRound2(num(rate) * num(base))
}
